import toast from 'react-hot-toast';

// Toast configuration constants
const TOAST_CONFIG = {
  baseStyle: {
    fontSize: '14px',
    padding: '12px 16px',
    borderRadius: '8px',
    color: '#fff',
    minWidth: '300px',
    maxWidth: '400px',
  },
  duration: {
    success: 4000,
    error: 5000,
    loading: Infinity,
    info: 4000,
  },
  iconSize: '20px',
};

// Success Toast
export const showSuccess = (message = 'Action successful!') => {
  toast.success(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#10B981', // Emerald-500
      borderLeft: '4px solid #059669', // Emerald-600
    },
    duration: TOAST_CONFIG.duration.success,
    iconTheme: {
      primary: '#fff',
      secondary: '#059669',
    },
  });
};

// Error Toast
export const showError = (message = 'Something went wrong!') => {
  toast.error(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#EF4444', // Red-500
      borderLeft: '4px solid #DC2626', // Red-600
    },
    duration: TOAST_CONFIG.duration.error,
    iconTheme: {
      primary: '#fff',
      secondary: '#DC2626',
    },
  });
};

// Loading Toast
export const showLoading = (message = 'Processing...') => {
  return toast.loading(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#3B82F6', // Blue-500
      borderLeft: '4px solid #2563EB', // Blue-600
    },
    duration: TOAST_CONFIG.duration.loading,
  });
};

// Approve Toast
export const showApprove = (message = 'Business Approved!') => {
  toast.success(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#4CAF50', // Green-500
      borderLeft: '4px solid #3B8E3D', // Green-600
    },
    duration: TOAST_CONFIG.duration.success,
    iconTheme: {
      primary: '#fff',
      secondary: '#3B8E3D',
    },
  });
};

// Reject Toast
export const showReject = (message = 'Business Rejected!') => {
  toast.error(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#F59E0B', // Amber-500
      borderLeft: '4px solid #D97706', // Amber-600
    },
    duration: TOAST_CONFIG.duration.error,
    iconTheme: {
      primary: '#fff',
      secondary: '#D97706',
    },
  });
};

// Deactivate Toast
export const showDeactivate = (message = 'Business Deactivated!') => {
  toast(message, {
    style: {
      ...TOAST_CONFIG.baseStyle,
      background: '#6B7280', // Gray-500
      borderLeft: '4px solid #4B5563', // Gray-600
    },
    duration: TOAST_CONFIG.duration.info,
    icon: '⚠️',
    iconTheme: {
      primary: '#fff',
      secondary: '#4B5563',
    },
  });
};

// Confirm Toast Dialog
export const showConfirmToast = ({
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  toast.custom(
    t => (
      <div className="bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="p-4">
          <h3 className="text-lg font-semibold text-gray-800">Confirm Action</h3>
          <p className="text-sm text-gray-600 mt-1">{message}</p>
        </div>
        <div className="flex justify-end bg-gray-50 px-4 py-3 gap-3">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            onClick={() => {
              toast.dismiss(t.id);
              onCancel?.();
            }}>
            {cancelText}
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            onClick={() => {
              toast.dismiss(t.id);
              onConfirm();
            }}>
            {confirmText}
          </button>
        </div>
      </div>
    ),
    {
      duration: Infinity,
      position: 'top-center',
      style: {
        padding: '0',
        background: 'transparent',
        boxShadow: 'none',
        maxWidth: '420px',
      },
    }
  );
};

export const dismissAllToasts = () => toast.dismiss();

export const dismissToast = id => toast.dismiss(id);
